import React, { useState, useEffect } from 'react'
import swal from 'sweetalert';
import Select from 'react-select';
import Axios from "axios"

export default function Addunit(props) {
    const [items, setitems] = useState({ UnitName: "", Amount: 0, company_id: props.companyid, description: "", bedno: "", farmno: ""})
    const [typevalue, settypevalue] = useState();
    const [type, settype] = useState([])
    useEffect(() => {
        fetchUsertype();
    }, [])
    async function fetchUsertype() {
       
        var res = await Axios.get(process.env.REACT_APP_APIURL + "Company/GetCompanies")

        var type = [];
        res.data.map((u) => {
            type.push({ value: u.company_id, label: u.name });
        })
        settype(type)
    }
    const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setitems({ ...items, [name]: value })
    }
    const refresh = () => {
        settypevalue(null)
        setitems({ ...items, UnitName: "", Amount: 0, company_id: props.companyid, description: "", bedno: "", farmno: "" });
    }
    const savemethod = async (data) => {
        data.companyid = typevalue.value;
        data.company_id = typevalue.value;
        const url = process.env.REACT_APP_APIURL + "FramUnit/AddFramUnit";
        await fetch(url, {
            method: "POST",
            headers: {
                'Accept': "json",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => {
            if (res.status == 200) {
                swal({
                    title: "Saved Successfully",
                    //  text: "Once deleted, you will not be able to recover this imaginary file!",
                    icon: "success"
                })
                refresh();
                
            }
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        savemethod(items);  
    }
    return (
        <div className="row">
            <div className="col-12 col-md-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-2 mt-5 text-center mx-auto">Add Farm Unit</h3>
                    </div>
                    <div className="card-body">

                        <div className="basic-form">
                            <form action="" onSubmit={handleSubmit}>
                                <div className="row flex-column align-items-center">
                                    <div className="mb-3 col-sm-6">
                                        <label className="form-label">Unit Name</label>
                                        <input type="text" autoComplete="off" className="form-control" name="UnitName" value={items.UnitName} onChange={handleInput} required />
                                    </div>
                                    {/*<div className="mb-3 col-sm-6">*/}
                                    {/*    <label className="form-label">Amount</label>*/}
                                    {/*    <input type="number" autoComplete="off" className="form-control" name="Amount" value={items.Amount} onChange={handleInput} required />*/}
                                    {/*</div>*/}
                                    <div className="mb-3 col-sm-6">
                                        <label className="form-label">No. of Beds</label>
                                        <input type="number" autoComplete="off" className="form-control" name="bedno" value={items.bedno} onChange={handleInput} required />
                                    </div>
                                    <div className="mb-3 col-sm-6">
                                        <label className="form-label">Comapany Name *</label>
                                        <Select options={type} value={typevalue} onChange={(e) => { settypevalue(e); setitems({ ...items, usertypeid: e.value }) }} />
                                    </div>
                                    <div className="mb-3 col-sm-6">
                                        <label className="form-label">Description</label>
                                        <textarea maxLength="500" rows="3" autoComplete="off" className="form-control" name="description" value={items.description} onChange={handleInput} required />
                                    </div>
                                    <div className="mb-3 col-sm-6">
                                        <label className="form-label">Farm No</label>
                                        <input type="text" autoComplete="off" className="form-control" name="farmno" value={items.farmno} onChange={handleInput} required />
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-primary">Save</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}